module.exports = __webpack_public_path__ + "static/img/SiteAdministrator.08147cfa.png";